// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { PriorAuthorizationResponsePatient } from './priorAuthorizationResponsePatient.js';
import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class PriorAuthorizationResponse {
    'authorizationNumber'?: string | null;
    'statusDateTime'?: Moment | null;
    'dueDate'?: Moment | null;
    'expirationDate'?: Moment | null;
    'message'?: string | null;
    'providerPin'?: string | null;
    'startDate'?: Moment | null;
    'status'?: string | null;
    'externalId'?: string | null;
    'ssoUrl'?: string | null;
    'notificationSso'?: string | null;
    'patient': PriorAuthorizationResponsePatient | null;
    'ndc'?: string | null;
    'daysSupply'?: string | null;
    'quantity'?: string | null;
    'formTitle'?: string | null;
    'faxedDate'?: Moment | null;
    'emailedDate'?: Moment | null;
    'firstLoginDate'?: Moment | null;
    'startedByHcp'?: string | null;
    'communicationDate'?: Moment | null;
    'communicationType'?: string | null;
    'communicationStatus'?: string | null;
    'transactionCorrelationId'?: number;
    'transactionDateTime'?: Moment;
    'transactionId'?: string | null;
    'transactionMessage'?: string | null;
    'transactionStatus'?: boolean;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof PriorAuthorizationResponse>> = [
        {
            "name":     "authorizationNumber",
            "baseName": "authorizationNumber",
            "type":     "string"
        },
        {
            "name":     "statusDateTime",
            "baseName": "statusDateTime",
            "type":     "Date"
        },
        {
            "name":     "dueDate",
            "baseName": "dueDate",
            "type":     "Date"
        },
        {
            "name":     "expirationDate",
            "baseName": "expirationDate",
            "type":     "Date"
        },
        {
            "name":     "message",
            "baseName": "message",
            "type":     "string"
        },
        {
            "name":     "providerPin",
            "baseName": "providerPin",
            "type":     "string"
        },
        {
            "name":     "startDate",
            "baseName": "startDate",
            "type":     "Date"
        },
        {
            "name":     "status",
            "baseName": "status",
            "type":     "string"
        },
        {
            "name":     "externalId",
            "baseName": "externalId",
            "type":     "string"
        },
        {
            "name":     "ssoUrl",
            "baseName": "ssoUrl",
            "type":     "string"
        },
        {
            "name":     "notificationSso",
            "baseName": "notificationSso",
            "type":     "string"
        },
        {
            "name":     "patient",
            "baseName": "patient",
            "type":     "PriorAuthorizationResponsePatient"
        },
        {
            "name":     "ndc",
            "baseName": "ndc",
            "type":     "string"
        },
        {
            "name":     "daysSupply",
            "baseName": "daysSupply",
            "type":     "string"
        },
        {
            "name":     "quantity",
            "baseName": "quantity",
            "type":     "string"
        },
        {
            "name":     "formTitle",
            "baseName": "formTitle",
            "type":     "string"
        },
        {
            "name":     "faxedDate",
            "baseName": "faxedDate",
            "type":     "Date"
        },
        {
            "name":     "emailedDate",
            "baseName": "emailedDate",
            "type":     "Date"
        },
        {
            "name":     "firstLoginDate",
            "baseName": "firstLoginDate",
            "type":     "Date"
        },
        {
            "name":     "startedByHcp",
            "baseName": "startedByHcp",
            "type":     "string"
        },
        {
            "name":     "communicationDate",
            "baseName": "communicationDate",
            "type":     "Date"
        },
        {
            "name":     "communicationType",
            "baseName": "communicationType",
            "type":     "string"
        },
        {
            "name":     "communicationStatus",
            "baseName": "communicationStatus",
            "type":     "string"
        },
        {
            "name":     "transactionCorrelationId",
            "baseName": "transactionCorrelationId",
            "type":     "number"
        },
        {
            "name":     "transactionDateTime",
            "baseName": "transactionDateTime",
            "type":     "Date"
        },
        {
            "name":     "transactionId",
            "baseName": "transactionId",
            "type":     "string"
        },
        {
            "name":     "transactionMessage",
            "baseName": "transactionMessage",
            "type":     "string"
        },
        {
            "name":     "transactionStatus",
            "baseName": "transactionStatus",
            "type":     "boolean"
        },
    ];

    static getAttributeTypeMap() {
        return PriorAuthorizationResponse.attributeTypeMap;
    }
}
